module.exports = __webpack_public_path__ + "static/assets/0c43423e432fbc75771085b8c8beca37.png";